export default __webpack_public_path__ + "static/media/logo512.2880737e.png";